///////////////////
// Auto-generated
// Do not edit!!!
///////////////////
import { Component } from '@angular/core';
import { KbChartsBaseComponent } from './../charts.base.component';

@Component({
    selector: 'kb-donut-charts',
    templateUrl: './donut-charts.component.html',
})
export class KbDonutChartsComponent extends KbChartsBaseComponent {}



// WEBPACK FOOTER //
// C:/Repositories/wfa3/SupplierPortal/app/src/app/shared/components/donut-charts/donut-charts.component.ts